// extracted by mini-css-extract-plugin
export var errorIcon = "_ny-1";
export var nameLogo = "_ny-0";